import i18n from "i18next"
import { initReactI18next } from "react-i18next";
import enResources from "./en";
import frResources from "./fr";

const LangEn = 'en';
const LangFr = 'fr';

const resources = {
  en: { translation: enResources },
  fr: { translation: frResources },
};

const urlLng = window.location.pathname.split("/")[1];
const defaultLng = [LangEn, LangFr].includes(urlLng) ? urlLng : LangEn;

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: LangEn,
  lng: defaultLng,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
